import { Button, DatePicker, Form, Row, Space } from 'antd';
import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDoctors } from '../../../../appRedux/actions';
import {
  getIndividualCommissionMedical
} from '../../../../appRedux/actions/Reports';
import {
  buttonLabel,
  dateFormat,
  formConfig,
  placeHolders
} from '../../../../constants';
import { CustomSelect } from '../../../uiComponents';
import { getFullName } from '../../../../util';

export const IndividualCommissionMedicalFilter = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const { doctors } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(getDoctors());
  }, [dispatch]);

  const onSubmit = (values) => {
    if (values.date)
      values.date = values.date.map((date) => moment(date)?.format(dateFormat));

    dispatch(getIndividualCommissionMedical(values));
  };

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="date">
            <RangePicker format={dateFormat} />
          </Form.Item>
          <Form.Item name="userId">
            <CustomSelect
              placeholder={placeHolders.medic}
              style={{ minWidth: '200px' }}
              options={doctors?.map(
                ({ id, name, lastName, motherLastName }) => ({
                  value: id,
                  label: getFullName({ name, lastName, motherLastName }),
                })
              )}
            ></CustomSelect>
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
